let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("8ETP5")]).then(() => parcelRequire('9tt3A'));